module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page6",
      "title": "6"
    }
  }, [_c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_001",
      "src": "images/page006_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/page008"
    }
  }, [_c('span', {
    staticClass: "list_br1"
  }, [_vm._v("Acknowledgments ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_002",
      "src": "images/page006_02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/page009#recpage9"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Introduction: Welcome to the Plant-Based Party ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_003",
      "src": "images/page006_03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/page033#recpage33"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Breakfast")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_004",
      "src": "images/page006_04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page073#recpage73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Bakery (Muffins, Biscuits, Breads, and More) ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_005",
      "src": "images/page006_05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page088#recpage88",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Sandwiches ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_006",
      "src": "images/page006_06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page116#recpage116",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Burgers ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_007",
      "src": "images/page006_07.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page126#recpage126",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Veggie Sides")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_008",
      "src": "images/page006_08.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page143#recpage143",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Cakes, Balls, and Fritters ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_009",
      "src": "images/page006_09.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page152#recpage152",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Salads ")])])])]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page7",
      "title": "7"
    }
  }, [_c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_010",
      "src": "images/page006_10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page184#recpage184",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Bowls ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_011",
      "src": "images/page006_11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page195#recpage195",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Appetizers, Sides, Snacks, and Party Platters ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_012",
      "src": "images/page006_12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page217#recpage217",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Entrées ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_013",
      "src": "images/page006_13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page254#recpage254",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Soups ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_014",
      "src": "images/page006_14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page273#recpage273",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Desserts ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_015",
      "src": "images/page006_15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page324#recpage324",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("Drinks, Sips, and Smoothies ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_016",
      "src": "images/page006_16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page338#recpage338",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("For the Kids ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": "",
      "id": "page006_017",
      "src": "images/page006_17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/page345#recpage345",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blueh"
  }, [_vm._v("12 Happy Life Menus ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group"
  }, [_c('p', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list_br1"
  }, [_vm._v("Index")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46d9378c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/page006.vue
// module id = 69
// module chunks = 0